import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, FormItem, TextArea } from 'carbon-components-react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { insertDmService } from '../../services/Api';

class CommentModal extends Component {
  static propType = {
    onRef: PropTypes.func,
    onSave: PropTypes.func,
  };

  state = {
    open: false,
    commentArea: {
      value: null,
    },
    observacao: '',
    sugestao: '',
    saving: false,
  };

  componentDidMount() {
    const { onRef } = this.props;
    if (onRef) {
      onRef(this);
    }

    const user = JSON.parse(localStorage.getItem('user'));
    const nivel = (user.nivel || {}).id;
    this.setState({ nivel });
  }

  open = () => {
    this.setState({ open: true });
  };

  close = () => {
    this.setState({ open: false });
  };

  save = async () => {
    const { orderId, onSave, updateCount } = this.props;
    const {
      open, commentArea, observacao, sugestao,
    } = this.state;

    if (!commentArea.value && open) {
      return toast.warning('Selecione a área do comentário');
    }
    if (!observacao && open) {
      return toast.warning('Preencha os campos observação');
    }
    if (!open) {
      return null;
    }

    this.setState({ saving: true });

    try {
      await insertDmService('/Comentario', {
        itemPedido: orderId,
        observacao,
        sugestao,
        bloco: commentArea.label,
      });
      await onSave();
      await updateCount(orderId);
      await this.setState({
        open: false,
        saving: false,
        observacao: '',
        sugestao: '',
        commentArea: { value: null },
      });
      toast.success('Comentário enviado.');
    } catch (e) {
      console.log(e);
      this.setState({ saving: false });
      toast.error('Ocorreu um problema ao enviar o comentário.');
    }
    return undefined;
  };

  render() {
    const {
      open, observacao, sugestao, saving, commentArea, nivel
    } = this.state;

    return (
      <Modal
        id="comment-modal"
        open={open}
        onRequestSubmit={saving ? () => null : this.save}
        onRequestClose={this.close}
        modalHeading="Adicionar Comentário"
        primaryButtonText="Incluir"
        secondaryButtonText="Cancelar"
      >
        <div>
          <FormItem>
            <label className="bx--label">Área do Comentário</label>
            <Select
              className="dmjob-select"
              name="area"
              options={[
                { value: 1, label: 'Unidades e Lojas' },
                { value: 2, label: 'Filtros' },
                { value: 3, label: 'Data de Envios' },
                { value: 4, label: 'Mensagem' },
                { value: 5, label: 'SAC' },
              ]}
              value={commentArea.value}
              onChange={obj => this.setState({ commentArea: obj })}
              placeholder="Selecione uma área"
              isClearable={false}
              isSearchable={false}
            />
          </FormItem>
          <FormItem className="v-md-margin">
            <TextArea
              id="observacao"
              labelText="Observação"
              placeholder="digite"
              onChange={event => this.setState({ observacao: event.target.value })}
              value={observacao}
            />
          </FormItem>
          {nivel === 10 && (
            <FormItem className="v-md-margin">
              <TextArea
                id="sugestao"
                labelText="Sugestão"
                placeholder="digite"
                onChange={event => this.setState({ sugestao: event.target.value })}
                value={sugestao}
              />
            </FormItem>
          )}
        </div>
      </Modal>
    );
  }
}

export default CommentModal;



// WEBPACK FOOTER //
// ./src/components/Modal/CommentModal.js